const ApiAttributesKeys = {
  chapterIdKey: 'chapter_id',
  readingNameKey: 'name',
  readingIdKay: 'reading_id',
  questionIdKey: 'id',
  questionKey: 'question',
  isAttemptedKey: 'frm_question_stat.answer_status',
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Questionbank/QuestionsViewList/ApiAttributesKays.js